module.exports = __webpack_public_path__ + "static/img/1038_big.4558462.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1038_big.png
// module id = Vai2
// module chunks = 1